/** @format */

import React from "react";
import { ReactComponent as CancelIcon } from "images/svg/x.svg";
import dayjs from "dayjs";

const AttendanceElements = ({
  data,
  fellows,
  handleSelectAll,
  setProgram,
  setCohorts,
  setSchedule,
}) => {
  return (
    <>
      <div className="card-header">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <div className="d-flex  justify-content-between  align-items-center">
            <h4 className="card-title text-pigment-green me-4">All Fellows</h4>

            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-wrap">
                {data?.program && (
                  <div className="attendance-type-pill me-2 mb-2">
                    <span>
                      Type of Program: <strong>{data?.program}</strong>
                    </span>
                    <button
                      onClick={() => {
                        setProgram(null);
                        setCohorts(null);
                        setSchedule(null);
                      }}
                    >
                      <CancelIcon />
                    </button>
                  </div>
                )}

                {data?.cohort && (
                  <div className="attendance-type-pill me-2 mb-2">
                    <span>
                      Cohort: <strong>{data?.cohort}</strong>
                    </span>
                    <button
                      onClick={() => {
                        setCohorts(null);
                        setSchedule(null);
                      }}
                    >
                      <CancelIcon />
                    </button>
                  </div>
                )}

                {data?.schedule && (
                  <div className="attendance-type-pill mb-2">
                    <span>
                      Time Period:{" "}
                      <strong>{`
                      ${dayjs(data?.schedule.start_date).format("MMMM D, YYYY")}
                                                   
                      ${dayjs(data?.schedule?.end_date).format(
                        "MMMM D, YYYY"
                      )}`}</strong>
                    </span>
                    <button
                      onClick={() => {
                        setSchedule(null);
                      }}
                    >
                      <CancelIcon />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {fellows?.length > 0 && (
            <div>
              <button
                className="btn mark-all-btn text-white"
                onClick={handleSelectAll}
              >
                Mark All
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.375 4.5V19.5C21.375 19.9973 21.1775 20.4742 20.8258 20.8258C20.4742 21.1775 19.9973 21.375 19.5 21.375H4.5C4.00272 21.375 3.52581 21.1775 3.17417 20.8258C2.82254 20.4742 2.625 19.9973 2.625 19.5V4.5C2.625 4.00272 2.82254 3.52581 3.17417 3.17417C3.52581 2.82254 4.00272 2.625 4.5 2.625H19.5C19.9973 2.625 20.4742 2.82254 20.8258 3.17417C21.1775 3.52581 21.375 4.00272 21.375 4.5ZM19.125 4.875H4.875V19.125H19.125V4.875Z"
                    fill="#F0F2FB"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AttendanceElements;
